import React from 'react'

function Header() {
    return (
        <React.Fragment>
            <div className='container-box banner-container' id="recruitHR-banner-container">
                <div className='overlay'></div>
                <div className='row'>
                    <div className='col'>
                        <h1>チームについて</h1>
                        <h3>OUR TEAM</h3>
                    </div>
                </div>
            </div>
            <div className='container-box ' id='recruitHR-tagline-container'>                    
                <div className='row'>
                    <div className='col-12'>
                        <h1>必要なのは、失敗を恐れず、決して諦めず、挑戦し続ける姿勢です。</h1>
                        <p>
                            弊社の求める人材について、能力的な制限はありません。
                            自分が興味のあることについて何でも挑戦する、チャレンジ精神が旺盛な人を期待しています。
                            大切なのは、意欲を持って仕事に取り組み、学び続けること。
                            仲間とともに成長し、リーダーシップを培っていきましょう。
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Header
